import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Draggable from 'react-draggable';

import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_CHAT_INSERT_ASSIGNEE } from '../../constants/menuPermissionConstant';
import IconFloatingButton from '../../assets/icons/IconFloatingButton';
import ChatWindow from './ChatWindow';

const FloatingButton = () => {
    const userDetail = useSelector(state => state.authentication.userDetail);
    const [showChatWindow, setShowChatWindow] = useState(false);
    const [position, setPosition] = useState({
        x: window.innerWidth - 115,
        y: -20
    });
    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [totalUnseenMessage, setTotalUnseenMessage] = useState(0);

    const handleStart = (event) => {
        setIsDragging(true);
        setDragOffset({
            x: event.clientX - position.x,
            y: event.clientY - position.y,
        });
    };

    const handleDrag = (event) => {
        if (isDragging) {
            setPosition({
                x: event.clientX - dragOffset.x,
                y: event.clientY - dragOffset.y,
            });
        }
    };

    const handleStop = (e, data) => {
        const center = window.innerWidth / 2;
        setPosition({ x: 20, y: data.y });
        if (data.x < center) {
        } else {
            setPosition({ x: window.innerWidth - 115, y: data.y });
        }
        setIsDragging(false);
    };

    return (
        <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_CHAT_INSERT_ASSIGNEE]} userPermission={userDetail.permissions}>
            <Draggable bounds="parent" position={position} onStart={handleStart} onDrag={handleDrag} onStop={handleStop} handle=".handle">
                <div className="fixed left-0 bottom-0 z-10 transition-all duration-200 ease-out">
                    <div className="cursor-move handle relative" onDoubleClick={() => setShowChatWindow(!showChatWindow)}>
                        <IconFloatingButton />
                        {totalUnseenMessage > 0 && <p className="h-5 w-5 flex justify-center items-center bg-darkred rounded-full text-sm text-white absolute top-0 right-0">{totalUnseenMessage}</p>}
                    </div>
                    <div className={showChatWindow ? "opacity-100 transition-all duration-200 transform translate-y-0" : "opacity-0 pointer-events-none transition-all duration-200 transform translate-y-5"}>
                        <ChatWindow
                            className={position.x < window.innerWidth / 2 ? Math.abs(position.y) > window.innerHeight / 2 ? "absolute left-0 top-5" : "absolute left-0 bottom-24" : Math.abs(position.y) > window.innerHeight / 2 ? "absolute right-0 top-5" : "absolute right-0 bottom-24"}
                            handleShowChatWindow={() => setShowChatWindow(!showChatWindow)}
                            handleSetTotalUnseenMessage={data => setTotalUnseenMessage(data)}
                            showChatWindow={showChatWindow}
                        />
                    </div>
                </div>
            </Draggable>
        </CheckPermissionComponent>
    );
};

export default FloatingButton;
